import { render, staticRenderFns } from "./PreviewSideBar.vue?vue&type=template&id=dd861854&scoped=true"
import script from "./PreviewSideBar.vue?vue&type=script&lang=js"
export * from "./PreviewSideBar.vue?vue&type=script&lang=js"
import style0 from "./PreviewSideBar.vue?vue&type=style&index=0&id=dd861854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd861854",
  null
  
)

export default component.exports